(ns app.domain.file.model
  (:require [core.db.child-entity :as child]
            [schema.core :as s]))

(def file-categories
  #{:file.category/verdict-image
    :file.category/verdict-page
    :file.category/form-image
    :file.category/form-file
    :file.category/sign-off-form
    :file.category/sign-off-upload
    :file.category/approval-attachment
    :file.category/inspection-attachment
    :file.category/shapefile
    :file.category/order
    :file.category/signed-order
    :file.category/receipt
    :file.category/occupancy-permit
    :file.category/inspection-report
    :file.category/code-enforcement-report
    :file.category/report
    :file.category/agreement
    :file.category/council-decision
    :file.category/committee-meeting-agenda
    :file.category/public-notice-document
    :file.category/import-data
    :file.category/signed-verdict
    :file.category/document-fragment
    :file.category/bill-pdf
    ;; info spreadsheet contained in an export package
    :file.category/export-info
    ;; forms pdf included in an export package
    :file.category/export-forms
    ;; reserved - currently, export package is not stored, but that
    ;; may change in the future
    :file.category/export-package
    :file.category/media-attachment
    ;; a letter generated with cloudpermit, e.g. for code enforcement
    :file.category/letter
    ;; a report spreadsheet
    :file.category/reporting-report
    :file.category/admin-package-pdf
    ;; a review report uploaded by an external plan review / mark-up software
    :file.category/external-plan-review-report
    :file.category/branding-logo
    :file.category/escrow-attachment
    :file.category/complaint-photo
    :file.category/rag-file
    :file.category/stamp-image
    :file.category/meeting-image
    :file.category/attachment-candidate
    :file.category/condition-attachment
    #__})

(s/defschema FileCategory (apply s/enum file-categories))

(def rag-processing-states
  "States of external (sammatti) RAG processing for a user-uploaded AI chat file."
  #{:file.rag-processing-state/in-progress
    :file.rag-processing-state/rule-extraction-in-progress
    :file.rag-processing-state/success
    :file.rag-processing-state/failed
    :file.rag-processing-state/skipped})

(s/defschema RagProcessingState (apply s/enum rag-processing-states))

(s/defn category-is-fn
  "Create a predicate function that check that the category of a file
  is one of the specified."
  [& categories :- [FileCategory]]
  (let [categories (set categories)]
    (fn [{:file/keys [category]}]
      (contains? categories category))))

(def ^{:arglists '([parent])} file-children
  (child/child-entities-of-type-fn :entity.type/file))

(def ^:dynamic size-limits
  {:file.category/branding-logo   (* 512 1024)     ;; 0.5MB
   :file.category/complaint-photo (* 10 1024 1024) ;; 10 MB
   :file.category/form-image      (* 512 1024)     ;; 0.5MB
   :file.category/meeting-image   (* 512 1024)})   ;; 0.5MB
